import _ from 'lodash';
import { connect } from 'react-redux';
import { SurveyStep } from '../../models';
import { IApplicationState } from '../../store/index';
import { ActionCreators as ReportingSetupActionCreators } from '../../store/ReportingSetupStore';
import { ActionCreators as SurveyBuilderActionCreators } from '../../store/SurveyBuilderStore';
import { ActionCreators as SurveyActionCreators } from '../../store/SurveyStore';
import { SurveyPageStateSetterBase } from './SurveyPageStateSetterBase';

const mapDispatchToProps = {
	Get: (surveyId: number) => (dispatch: any) => {
		dispatch(ReportingSetupActionCreators.GetReportingSetupModel(surveyId));
		dispatch(ReportingSetupActionCreators.GetTrendGroups(surveyId));
		dispatch(ReportingSetupActionCreators.GetTrendSurveys(surveyId));
		dispatch(SurveyActionCreators.GetSurvey(surveyId));
	},
	...SurveyBuilderActionCreators,
};

export const ReportingPageStateSetter = connect(
	(state: IApplicationState) => ({
		...state.reportingSetup,
		...state.surveyBuilder,
		isLoading: state.reportingSetup.loading,
		currentStep: SurveyStep.Reporting,
	}),
	mapDispatchToProps,
)(SurveyPageStateSetterBase);
